import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '@wealthlane/api-services/wealthlane-customer-service';
import { DisbursementService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetDisbursementContainerStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const DisbursementContainerStatus = useQuery(
    ['getDisbursementContainerStatus'],
    async () => {
      return await handleRequest(
        DisbursementService.getApiAwardSettlementApiAppDisbursementDisbursementContainerStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return DisbursementContainerStatus;
};

export default useGetDisbursementContainerStatus;
